import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import DisabledImage from "../../../../src/Resources/Images/disable.png";

import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import {
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  RestartAltIcon,
  DeleteIcon,
  NotInterestedIcon,
  AddIcon,
} from "../../../Resources/Icons/icons";
import moment from "moment";
import AddBranchConfig from "./AddBranchConfig";
import {
  GetUser,
  GetCompany,
  GetBookingCode,
  GetPolicyFindbyId,
  FilterPolicyList,
  DeleteBranchConfig,
  GetBranchConfigByBranchManagerId,
  DisableBranchConfig,
  GetBranchConfigById,
  GetSubBookingCode,
  deleteMultipleBranchConfigById,
  disableMultipleBranchConfigById,
} from "../../../Service/_index";
import Loader from "../../../UiComponents/Loader/Loader";
import { DatePicker, Radio } from "antd";
import { CSVLink } from "react-csv";
import { useEffect } from "react";
import dayjs from "dayjs";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import TabFilter from "../../Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "user",
    placeMent: true,
    disablePadding: false,
    label: "User",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code - Sub Booking Code",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product - Sub Product",
  },
  {
    id: "policyType",
    placeMent: true,
    disablePadding: false,
    label: "Policy Type",
  },
  {
    id: "CC",
    placeMent: true,
    disablePadding: false,
    label: "CC / GVW",
  },
  {
    id: "location",
    placeMent: true,
    disablePadding: false,
    label: "RTO Code",
  },
  {
    id: "PACover",
    placeMent: true,
    disablePadding: false,
    label: "PA Cover",
  },
  {
    id: "OD",
    placeMent: true,
    disablePadding: false,
    label: "OD %",
  },
  {
    id: "TP",
    placeMent: true,
    disablePadding: false,
    label: "TP %",
  },
  {
    id: "Net",
    placeMent: true,
    disablePadding: false,
    label: "NET %",
  },
  {
    id: "ActiveDate",
    placeMent: true,
    disablePadding: false,
    label: "Active Date",
  },
  {
    id: "DisableDate",
    placeMent: true,
    disablePadding: false,
    label: "Disable Date",
  },
];

const FilterOption = [
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 1,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 2,
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const BranchConfig = () => {
  const todayDate = new Date();
  const LastWeekDate = new Date();
  LastWeekDate.setDate(LastWeekDate.getDate() - 7);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]); //Changed by Arun
  console.log(subBookingCodeDetails, "SBCD");
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState(null); //Changed by Arun
  console.log(selectedSubBookingCode, "SSBC");
  const [openMultipleDeleteConfirmBox, setOpenMultipleDeleteConfirmBox] =
    useState(false); // Changed by Arun
  const [checkedRows, setCheckedRows] = useState([]); //Changed by Arun for Checkbox
  const [checkboxRows, setCheckboxRows] = useState({}); //Changed by Arun for Checkbox
  const [openLoader, setOpenLoader] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  console.log(selectedCompany, "SC");
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [branchManagerDetails, setBranchManagerDetails] = useState([]);
  const [selectedBranchManager, setSelectedBranchManager] = useState(null);
  console.log(selectedBranchManager, "SBM");
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [disabledDate, setDisabledDate] = useState("React-disable");
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [reqType, setReqType] = useState(null);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [selectedTab, setSelectedTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    // isView: true,
    isEdit: true,
    isDelete: true,
    isSearch: true,
    isSwitch: true,
    isMultiDelete: true,
    type: "userConfiguration",
  });

  const FilteredData = policyList.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.user},${el?.company},${el?.bookingCode},${el?.product},${el?.policyType},${el?.location}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    console.log(newValue, "VS");
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    if (selectedOption.value === 1) {
      ActiveFunction();
    } else if (selectedOption.value === 2) {
      DisableFunction();
    }
  };

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  //Changed by Arun for Checkbox
  const checked = (checked, id, index) => {
    setCheckboxRows((prev) => ({ ...prev, [index]: checked }));
    checked
      ? checkedRows.push(id)
      : checkedRows.splice(checkedRows.indexOf(id), 1);
    console.log("checked rows ", checkedRows);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const EditBranchConfig = (row) => {
    GetBranchConfigById(row._id).then((res) => {
      console.log(res);
      setOpenDrawer(true);
      setFormType("edit");
      setSelectedData(res.data);
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.user},${el?.company},${el?.bookingCode},${
              el?.subBookingCode
            },${el?.product},${el?.subProduct},${el?.policyType},${el?.CC},${
              el?.PACover
            },${el?.OD},${el?.TP},${el?.Net},${moment(el?.disableDate).format(
              "DD/MM/YYYY"
            )},${moment(el?.activeDate).format("DD/MM/YYYY")}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const GetBranchManagerDetails = () => {
    GetUser({ isAscending: true }).then((res) => {
      const modifiedUser = res?.data?.map((e) => {
        return {
          ...e,
          label: e.name,
          value: e._id,
        };
      });
      const FilterUserType = modifiedUser?.filter(
        (item) => item.userType.includes("branchManager") && item.isEnabled
      );
      setBranchManagerDetails(FilterUserType);
    });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCode);
    });
  };

  // Changed by Arun
  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      const filteredSubBookingCode = modifiedSubBookingCode.filter(
        (item) =>
          item.bookingCodeId === selectedBookingCode?._id ||
          item.bookingCodeId === selectedBookingCode
      );
      setSubBookingCodeDetails(filteredSubBookingCode);
    });
  };

  // Changed by Arun
  useEffect(() => {
    // if (!selectedBranchManager) return;
    if (!reqType) return; // Wait for reqType to be set

    const branchManagerId = selectedBranchManager?._id || selectedBranchManager;
    // if (!branchManagerId) return;
    const branchManagerIdString = branchManagerId || "undefined";

    GetBranchConfigByBranchManagerId(branchManagerIdString, {
      requestType: reqType,
      companyId: selectedCompany?._id || selectedCompany,
      bookingCodeId: selectedBookingCode?._id || selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode,
    })
      .then((res) => {
        const formattedData = res.data.map((e) => {
          return {
            ...e,
            ActiveDate: moment(e?.activeDate).format("DD/MM/YYYY"),
            ...(e.disableDate &&
              reqType === "DISABLED" && {
                DisableDate: moment(e?.disableDate).format("DD/MM/YYYY"),
              }),
          };
        });
        setPolicyList(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching branch config:", error);
      });
  }, [
    selectedBranchManager,
    selectedCompany,
    selectedBookingCode,
    selectedSubBookingCode,
    reqType,
  ]);

  useEffect(() => {
    GetSubBookingCodeDetails();
  }, [selectedBookingCode]);

  useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
    GetBranchManagerDetails();
    // Set initial reqType to ACTIVE
    setReqType("ACTIVE");
  }, []);

  const header = [
    { label: "User", key: "user" },
    { label: "Company Name", key: "company" },
    { label: "Booking Code", key: "bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCode" },
    { label: "Product", key: "product" },
    { label: "Sub Product", key: "subProduct" },
    { label: "Policy Type", key: "policyType" },
    { label: "CC", key: "CC" },
    { label: "GVW", key: "GVW" },
    { label: "RTO Code", key: `location` },
    { label: "PA Cover", key: "PACover" },
    { label: "OD%", key: "OD" },
    { label: "TP%", key: "TP" },
    { label: "NET%", key: "Net" },
    { label: "Active Date", key: "ActiveDate" },
    { label: "Disable Date", key: "DisableDate" },
  ];
  const csvFile = {
    filename: "Branch Payable Data",
    headers: header,
    data: policyList,
  };

  const ActiveFunction = () => {
    const requestType = "ACTIVE";
    setReqType("ACTIVE");
    // if (!selectedBranchManager) {
    //   return;
    // }
    GetBranchConfigByBranchManagerId(
      selectedBranchManager?._id || selectedBranchManager || "undefined",
      {
        requestType: requestType,
        companyId: selectedCompany?._id || selectedCompany,
        bookingCodeId: selectedBookingCode?._id || selectedBookingCode,
        subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode,
      }
    ).then((res) => {
      const data = res.data.map((e) => {
        return {
          ...e,
          ActiveDate: moment(e?.activeDate).format("DD/MM/YYYY"),
        };
      });
      setPolicyList(data);
    });
    setPage(0);
  };

  const DisableFunction = () => {
    const requestType = "DISABLED";
    setReqType("DISABLED");
    // if (!selectedBranchManager) {
    //   return;
    // }
    GetBranchConfigByBranchManagerId(
      selectedBranchManager?._id || selectedBranchManager || "undefined",
      {
        requestType: requestType,
        companyId: selectedCompany?._id || selectedCompany,
        bookingCodeId: selectedBookingCode?._id || selectedBookingCode,
        subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode,
      }
    ).then((res) => {
      const data = res.data.map((e) => {
        return {
          ...e,
          ActiveDate: moment(e?.activeDate).format("DD/MM/YYYY"),
          DisableDate: moment(e?.disableDate).format("DD/MM/YYYY"), //Changes by Arun
        };
      });
      setPolicyList(data);
    });
    setPage(0);
  };

  // Changed by Arun
  const DeleteMultipleBranchConfigData = () => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setOpenMultipleDeleteConfirmBox(true);
    }
  };

  // Changed by Arun
  const DeleteMultipleFunction = () => {
    deleteMultipleBranchConfigById(checkedRows).then((res) => {
      setCheckedRows([]);
      setCheckboxRows({});
      reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
      console.log("checked rows ", checkedRows);
      console.log("check box rows ", checkboxRows);
    });
    setOpenMultipleDeleteConfirmBox(false);
  };

  const DisableBranchConfigData = (row) => {
    setDisabledDate("React-disable");
    setOpenConfirmBox(true);
    setSelectedData(row);
  };

  const DisableBranchConfigFunction = (selectedDate) => {
    const requesttype = selectedData.isEnabled ? "true" : "false";
    const headers = {
      requesttype: requesttype,
      disableDate: selectedDate,
    };
    if (checkedRows.length > 0) {
      disableMultipleBranchConfigById(checkedRows, headers).then((res) => {
        setCheckedRows([]);
        setCheckboxRows({});
        reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
        setOpenConfirmBox(false);
      });
    } else {
      DisableBranchConfig(selectedData._id, headers).then((res) => {
        // ActiveFunction();
        reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
        setOpenConfirmBox(false);
      });
    }
  };

  const DeleteBranchConfigData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    DeleteBranchConfig(selectedData._id).then((res) => {
      reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
    });
    setOpenDeleteConfirmBox(false);
  };

  // Changed by Arun
  const DisableMultipleBranchConfigData = (row) => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setDisabledDate("React-disable");
      setOpenConfirmBox(true);
    }
  };

  const handleMultiDelete = (items) => {
    console.log(items, "II");
    setCheckedRows(items);
  };

  const handleClearAllState = () => {
    // Clear all filters including branch manager
    setSelectedBranchManager(null);
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedSubBookingCode(null);
    // Clear the policy list when all filters are cleared
    setPolicyList([]);
  };

  const handleSaveAllFilter = () => {
    // Don't show error if branch manager is not selected - the useEffect will handle data fetching
    // when the state updates. This prevents the error when selecting a branch manager
    // because React state updates are asynchronous.
    // if (!selectedBranchManager) {
    //   // Just return - the useEffect will handle fetching when branch manager is selected
    //   return;
    // }

    GetBranchConfigByBranchManagerId(
      selectedBranchManager?._id || selectedBranchManager || "undefined",
      {
        requestType: reqType || "ACTIVE",
        companyId: selectedCompany?._id || selectedCompany,
        bookingCodeId: selectedBookingCode?._id || selectedBookingCode,
        subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode,
      }
    ).then((res) => {
      const formattedData = res.data.map((e) => {
        return {
          ...e,
          ActiveDate: moment(e?.activeDate).format("DD/MM/YYYY"),
          ...(e.disableDate &&
            reqType === "DISABLED" && {
              DisableDate: moment(e?.disableDate).format("DD/MM/YYYY"),
            }),
        };
      });
      setPolicyList(formattedData);
    });
  };

  const handleClearSingleFilter = (filterId) => {
    // Show loader
    setOpenLoader(true);

    // Calculate updated filter values based on which filter is being cleared
    const updatedBranchManager =
      filterId === 1
        ? null
        : selectedBranchManager?._id || selectedBranchManager;
    const updatedCompany =
      filterId === 2 ? null : selectedCompany?._id || selectedCompany;
    const updatedBookingCode =
      filterId === 3 ? null : selectedBookingCode?._id || selectedBookingCode;
    const updatedSubBookingCode =
      filterId === 4 || filterId === 3
        ? null
        : selectedSubBookingCode?._id || selectedSubBookingCode;

    // Clear the specific filter based on ID
    if (filterId === 1) {
      setSelectedBranchManager(null);
    } else if (filterId === 2) {
      setSelectedCompany(null);
    } else if (filterId === 3) {
      setSelectedBookingCode(null);
      setSelectedSubBookingCode(null); // Also clear sub booking code
    } else if (filterId === 4) {
      setSelectedSubBookingCode(null);
    }

    // If branch manager is cleared, don't make API call
    // if (!updatedBranchManager) {
    //   setPolicyList([]);
    //   setOpenLoader(false);
    //   return;
    // }

    // Refresh data immediately with calculated values (without the cleared filter)
    GetBranchConfigByBranchManagerId(updatedBranchManager || "undefined", {
      requestType: reqType || "ACTIVE",
      companyId: updatedCompany || null,
      bookingCodeId: updatedBookingCode || null,
      subBookingCodeId: updatedSubBookingCode || null,
    })
      .then((res) => {
        const formattedData = res.data.map((e) => {
          return {
            ...e,
            ActiveDate: moment(e?.activeDate).format("DD/MM/YYYY"),
            ...(e.disableDate &&
              reqType === "DISABLED" && {
                DisableDate: moment(e?.disableDate).format("DD/MM/YYYY"),
              }),
          };
        });
        setPolicyList(formattedData);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const filterBoxData = [
    {
      id: 1,
      label: "Select Branch Manager",
      data: branchManagerDetails,
      setState: setSelectedBranchManager,
      value: selectedBranchManager,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Booking Code",
      data: bookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "single",
    },
    {
      id: 4,
      label: "Select SubBooking Code",
      data: subBookingCodeDetails,
      setState: setSelectedSubBookingCode,
      value: selectedSubBookingCode,
      type: "input",
      variation: "single",
    },
  ];

  const activeFiltersCount = [
    selectedBranchManager,
    selectedCompany,
    selectedBookingCode,
    selectedSubBookingCode,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Branch Configuration
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        startIcon={
                          <DeleteIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DeleteMultipleBranchConfigData()}
                      >
                        Delete
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button  w-100"
                        startIcon={
                          <NotInterestedIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DisableMultipleBranchConfigData()}
                      >
                        Disable
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                      >
                        <CSVLink
                          style={{ textDecoration: "none", color: "inherit" }}
                          {...csvFile}
                        >
                          Export
                        </CSVLink>
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => {
                          setOpenDrawer(true);
                          setFormType("add");
                          setSelectedData({});
                        }}
                      >
                        Create
                      </Button>
                      {/* <IconButton
                        sx={{
                          border: "1px solid #D0D5DD",
                          borderRadius: "8px",
                          padding: "8px",
                        }}
                      >
                        <ViewColumnOutlinedIcon />
                      </IconButton> */}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={true}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                {/* <Grid item xs={12} sm={8} md={8}></Grid> */}
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search User"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={headCells}
                // isServerSide={true}
                // handleOnClickBehaviour={OpenPolicyFile}
                handleEdit={EditBranchConfig}
                handleDelete={DeleteBranchConfigData}
                handleApprove={DisableBranchConfigData}
                handleMultiDelete={handleMultiDelete}
                // handleButton2={handleButton}
                tableTotalCount={filter.fn(policyList)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      {/* <Loader open={openLoader} /> */}

      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "60%",
            },
          },
        }}
      >
        {openDrawer ? (
          <AddBranchConfig
            setOpenDrawer={setOpenDrawer}
            selectedBranchManager={selectedBranchManager}
            ActiveFunction={ActiveFunction}
            selectedData={selectedData}
            formType={formType}
          />
        ) : null}
      </Dialog>

      <ConfirmBox
        setDisabledDate={setDisabledDate}
        disabledDate={disabledDate}
        mode="picker"
        open={openConfirmBox}
        title="Disable"
        content={
          disabledDate === "React-disable"
            ? "Please select the date ... !"
            : "Are you sure want to disable"
        }
        confirmButton="Disable"
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DisableBranchConfigFunction}
        icon={<NotInterestedIcon />}
        color="error"
        img={DisabledImage}
        subContent="Select a valid date before proceeding."
      />
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      <ConfirmBox
        open={openMultipleDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenMultipleDeleteConfirmBox}
        Function={DeleteMultipleFunction}
        icon={<DeleteIcon />}
        color="error"
      />
    </>
  );
};
export default BranchConfig;
